function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpotilitesWhite = function SvgSpotilitesWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 166"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 0a83 83 0 1 0 83 83A83 83 0 0 0 83 0ZM52.24 120.38a6.95 6.95 0 0 1-13.89 0V45.66a6.95 6.95 0 0 1 13.89 0Zm25.8 0a7 7 0 0 1-7 6.94 6.94 6.94 0 0 1-6.94-6.94V78.51a6.94 6.94 0 0 1 6.94-6.94 7 7 0 0 1 7 6.94Zm25.79 0a6.95 6.95 0 0 1-13.89 0V98.43a6.95 6.95 0 1 1 13.89 0Zm25.8 0a6.95 6.95 0 0 1-13.89 0v-55.8a6.95 6.95 0 1 1 13.89 0Z",
    style: {
      fill: "#fff"
    },
    "data-name": "Layer 1"
  })));
};

export default SvgSpotilitesWhite;